import { SearchInput } from '@mm/components';
import { useDebounce } from '@mm/hooks';
import {
  MyLeadsSearchQuery,
  MyLeadsFilterTypes,
} from '@mm/state/interfaces/myLeads';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useFilterParams } from '../use-filter-params';
import styles from './SearchContacts.module.css';

type Props = {
  filterParams: MyLeadsSearchQuery;
  setFilterParams: (params: MyLeadsSearchQuery) => void;
  className?: string;
};

export const SearchContacts = ({
  filterParams,
  setFilterParams,
  className,
}: Props) => {
  const [contactsSearchValue, setContactsSearchValue] = useState('');
  const [isMounted, setIsMounted] = useState(false);
  const KEY = 'full_name';
  const currentValue = filterParams.query?.attributes?.[KEY];

  const { getUpdatedFilterParams, shouldDisableFilters } = useFilterParams({
    filterParams,
  });
  const debouncedSearch = useDebounce(contactsSearchValue.trim(), 500);

  const onSearchContacts = () => {
    if (currentValue) {
      delete filterParams.query?.attributes?.[KEY];
    }

    const updatedQuery = getUpdatedFilterParams({
      key: KEY,
      value: debouncedSearch,
      isExisting: false,
      type: MyLeadsFilterTypes.attributes,
    });
    setFilterParams(updatedQuery);
  };

  useEffect(() => {
    if (isMounted) {
      onSearchContacts();
    }
    setIsMounted(true);
  }, [debouncedSearch]);

  useEffect(() => {
    if (!currentValue) {
      setContactsSearchValue('');
    }
  }, [currentValue]);

  return (
    <SearchInput
      css={{ container: classNames(styles.searchInput, className) }}
      placeholder="First Name, Last Name, Email"
      value={contactsSearchValue}
      onChange={event => setContactsSearchValue(event.target.value)}
      onSearch={onSearchContacts}
      disabled={shouldDisableFilters}
      maxLength={100}
    />
  );
};
